import React from 'react';

interface PendingAproveFilterProps {
  onClearSearch: () => void;
  onSearchTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  textInput: string;
}

const PendingAproveFilter: React.FC<PendingAproveFilterProps> = ({
  onSearchTextChange,
  textInput,
  onClearSearch,
}) => (
  <div className="panel-filters panel-filters-pending-approves">
    <div className="filter-input-wrapper filter-input-wrapper-pending-approves">
      <input
        type="text"
        placeholder="Filtrar"
        value={textInput}
        onChange={onSearchTextChange}
      />
      {textInput && (
        <button
          type="button"
          className="filter-clear-btn"
          onClick={onClearSearch}
          aria-label="Limpar busca"
        >
          <i className="pi pi-times" />
        </button>
      )}
    </div>
  </div>
);

export default React.memo(PendingAproveFilter);
